import Navbar from './Navbar'
import Footer from './Footer'
import { FC } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

const GuestLayout: FC = () => {
  const location = useLocation();
  return (
    <div className="flex flex-col h-screen overflow-visible justify-between">
      <Navbar />      
        <main className={`${location.pathname !== "/homepage" ? "container mx-auto flex-grow" : "flex-grow"}`}>
          <Outlet />
        </main>
      <Footer />
    </div>
  );
};

export default GuestLayout;